/**
 * Converts a locale string to a camelCase Sanity field name.
 * Works for both country-suffixed locales ("en-se" -> "localeEnSe") and bare
 * locales ("en" -> "localeEn"); every locale now has its own visibility toggle.
 */
export const localeToFieldName = (locale: string): string => {
    const parts = locale.split("-")

    return (
        "locale" +
        parts.map(part => part.charAt(0).toUpperCase() + part.slice(1)).join("")
    )
}
